import _ from "@lodash";
import { AppBar, Avatar, MuiThemeProvider, Toolbar, Typography } from "@material-ui/core";
import Constante from "Constante.json";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import LockPage from "app/Core/Components/ScreenLock/LockPage";
import SeletorEmpresa from "app/Core/Components/SeletorEmpresa/SeletorEmpresa";
import UpdateVersion from "app/Core/Components/UpdateVersion/UpdateVersion";
import ComunicadorApp from "app/Core/Funcionalidade/Comunicador/ComunicadorApp";
import * as Helpers from "app/Core/Helpers";
import history from "history.js";
import Planos from "app/Planos/index.json";
import React from "react";
import connect from "react-redux/es/connect/connect";
import Pagamento from "app/Core/Funcionalidade/Pagamento/Pagamento";

// eslint-disable-next-line react/prop-types
const FooterLayout2 = ({ footerTheme, settings = {}, empresa = null }) => {
  const { sistemas = null } = settings;

  return (
    <MuiThemeProvider theme={footerTheme}>
      <AppBar id="fuse-footer" className="relative z-10" color="default">
        <Toolbar className="px-16 py-0 flex items-center min-h-32">
          <div className="flex items-center">
            <SeletorEmpresa>
              <div className="flex text-center items-center">
                {!_.isNull(sistemas) && Object.keys(sistemas).length > 0 && !_.isNull(empresa) && !_.isUndefined(sistemas[empresa]) &&
                  <React.Fragment>
                    <Avatar
                      alt={"Avatar" + empresa}
                    >
                      {Helpers.getAcronimo(sistemas[empresa].nomesocial)}
                    </Avatar>
                    <Typography className="ml-8" color="textSecondary">{sistemas[empresa].nomesocial}</Typography>
                  </React.Fragment>
                }
              </div>
            </SeletorEmpresa>
            <XAPPButton
              tooltip={{ "title": "Home", "placement": "top" }}
              type="Icon"
              className=""
              onClick={() => history.push("/home")}
              icon={"home"}
            />
            {document.location.host.includes("local") &&
              <XAPPButton
                tooltip={{ "title": "Componente em homologação", "placement": "top" }}
                type="Icon"
                className=""
                onClick={() => history.push("/homolog")}
                icon={"devices"}
              />
            }
          </div>
          <div className="flex-1" />
          <div className="flex">
            {/* <DicasApp /> */}
            {!_.isNull(empresa) &&
              <Pagamento />
            }
            {Helpers.checkPlano(Planos.comunicador.chat, settings) &&
              <ComunicadorApp
                tipo={_.find(Constante.mensagem_tipos, { "id": "chat" })?.value}
                gerenciador={"chat"}
                local={`suporte_${empresa}`}
                empresa={Constante.idxapp}
                placeholder={"Como podemos lhe ajudar?"}
              />
            }
            <LockPage />
            {/* <TermoUso type="button" /> */}
            <UpdateVersion />
          </div>
        </Toolbar>
      </AppBar>
    </MuiThemeProvider>
  );
};


function mapStateToProps({ fuse, auth }) {
  return {
    footerTheme: fuse.settings.footerTheme,
    settings: auth.user.data.settings,
    user: auth.user.data,
    empresa: fuse.navigation.empresa
  };
}

export default connect(mapStateToProps)(FooterLayout2);

